import {DataTableState, RootState} from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';


type DataTableGetter = GetterTree<DataTableState, RootState>;

export const initialState = (): DataTableState => {
  return {
    initialState,
    paginationOptions: {},
  };
};

export const getters: DataTableGetter = {
  paginationOptions: (state) => state.paginationOptions,
  storedItemsPerPage: (state) => (key: string) => state.paginationOptions[key] ? state.paginationOptions[key].itemsPerPage : -1,
};

export const mutations: MutationTree<DataTableState> = {
  setItemsPerPage(state, options) {
    state.paginationOptions[options.key] = state.paginationOptions[options.key] || {};
    state.paginationOptions[options.key].itemsPerPage = options.itemsPerPage;
  },
};

export const actions: ActionTree<DataTableState, RootState> = {

};


export const datatable: Module<DataTableState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
